import axios from 'axios'
import API from './API.js'

export default class Online_session extends API {
  constructor() {
    super('online_session')
  }
  //online-session/join
  async Join(params) {
    const response = await axios.post(`online-session/join`, params)
    return response.data
  }
  async end(params) {
    const response = await axios.get(`online-session/end`,  { params })
    return response.data
  }
  //online-session/send-to-bbb

  async sendToBBB(params) {
    const response = await axios.get(`online-session/send-to-bbb`,  { params })
    return response.data
  }
  async reopen(id) {
    const response = await axios.post(`online-session/reopen/${id}`)
    return response.data
  }

}
